import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: '登录',
      component: resolve => require(['@/components/login.vue'], resolve),
      hidden: true
    },
    {
      path: '/fastHome',
      name: '主页面',
      component: resolve => require(['@/components/Home.vue'], resolve),
      children: [
        {
          path: '/inStore',
          name: '进库',
          nameEn:'Inbound',
          selected: '../../static/images/menu/ic_first_in_store_selected.png',
          normal: '../../static/images/menu/ic_first_in_store_normal.png',
          component: resolve => require(['@/components/documentPage.vue'], resolve),
          children: [
            {
              path: '/inStore/foreCastPage',
              component: resolve => require(['@/components/operationArea/foreCastPage.vue'], resolve),
              name: '仓库总览',
              nameEn:'Overview',
              selected: '../../static/images/menu/ic_fore_cast_selected.png',
              normal: '../../static/images/menu/ic_fore_cast_normal.png',
              warehouseType:[1,2,4]
            },
            {
              path: '/inStore/inStoreModelPage',
              component: resolve => require(['@/components/operationArea/inStoreModelPage.vue'], resolve),
              name: '入库',
              nameEn:'inbound',
              selected: '../../static/images/menu/ic_in_store_model_selected.png',
              normal: '../../static/images/menu/ic_in_store_model_normal.png',
              childArr:[
                '/inStore/inStorePage',
                '/inStore/inStoreScanPage',
                '/inStore/inStoreBatchPage',
                '/inStore/inStoreCapacityPage',
                '/inStore/submitCodeDownLoadPage',
              ],
              warehouseType:[1,2,4]
            },
            {
              path: '/inStore/inStorePage',
              component: resolve => require(['@/components/operationArea/inStorePage.vue'], resolve),
              name: '旧版入库',
              hidden: true
            },
            {
              path: '/inStore/inStoreScanPage',
              component: resolve => require(['@/components/operationArea/inStoreScanPage.vue'], resolve),
              name: '人工扫码',
              hidden: true
            },
            {
              path: '/inStore/inStoreBatchPage',
              component: resolve => require(['@/components/operationArea/inStoreBatchPage.vue'], resolve),
              name: '批量入库',
              hidden: true
            },
            {
              path: '/inStore/inStoreCapacityPage',
              component: resolve => require(['@/components/operationArea/capacity/inStoreCapacityPage.vue'], resolve),
              name: '大仓入库',
              hidden: true
            },
            {
              path: '/inStore/submitCodeDownLoadPage',
              component: resolve => require(['@/components/operationArea/submitCodeDownLoadPage.vue'], resolve),
              name: '确认码下载',
              hidden: true
            },
          ]
        },
        {
          path: '/storeOperation',
          name: '库内',
          nameEn:'In-Side',
          component: resolve => require(['@/components/documentPage.vue'], resolve),
          selected: '../../static/images/menu/ic_first_store_selected.png',
          normal: '../../static/images/menu/ic_first_store_normal.png',
          children: [
            {
              path: '/storeOperation/inputOrderCargoPage',
              component: resolve => require(['@/components/operationArea/inputOrderCargoPage.vue'], resolve),
              name: '物品清点',
              nameEn:'Inventory',
              selected: '../../static/images/menu/ic_input_cargo_selected.png',
              normal: '../../static/images/menu/ic_input_cargo_normal.png',
              childArr:[
                '/storeOperation/inputCargoCompletePage',
              ],
              warehouseType:[2]
            },
            {
              path: '/storeOperation/inputCargoCompletePage',
              component: resolve => require(['@/components/operationArea/inputCargoCompletePage.vue'], resolve),
              name: '物品录入',
              nameEn:'GoodsEntry',
              hidden: true
            },
            {
              path: '/storeOperation/onShelfPage',
              component: resolve => require(['@/components/operationArea/onShelfPage.vue'], resolve),
              name: '上/下架',
              nameEn:'Shelf',
              selected: '../../static/images/menu/ic_on_shelf_selected.png',
              normal: '../../static/images/menu/ic_on_shelf_normal.png',
              warehouseType:[1,2]
            },
            //2020-05-28 傲天同意暂时去除
            // {
            //   path: '/examinePage',
            //   component: resolve => require(['@/components/operationArea/examinePage.vue'], resolve),
            //   name: '客户验货',
            //   selected: '../../static/images/home/examine_selected.png',
            //   normal: '../../static/images/home/examine_normal.png',
            // },
            {
              path: '/storeOperation/unPackPage',
              component: resolve => require(['@/components/operationArea/unPackPage.vue'], resolve),
              name: '分包',
              nameEn:'Subcontract',
              selected: '../../static/images/menu/ic_2nd_pack_selected.png',
              normal: '../../static/images/menu/ic_2nd_pack_normal.png',
              childArr:[
                '/storeOperation/collectOrder',
                '/storeOperation/unPackHistoryPage',
                '/storeOperation/unPackNextPage',
                '/storeOperation/unPackCompletePage',
                '/storeOperation/unPackBagPage',
              ],
              warehouseType:[2]
            },
            {
              path: '/storeOperation/collectOrder',
              component: resolve => require(['@/components/operationArea/collectOrderPage.vue'], resolve),
              name: '订单归集',
              nameEn:'OrderCollect',
              hidden: true
            },
            {
              path: '/storeOperation/unPackNextPage',
              component: resolve => require(['@/components/operationArea/unPackNextPage.vue'], resolve),
              name: '二次打包指令',
              hidden: true
            },
            {
              path: '/storeOperation/unPackCompletePage',
              component: resolve => require(['@/components/operationArea/unPackCompletePage.vue'], resolve),
              name: '二次打包',
              hidden: true
            },
            {
              path: '/storeOperation/unPackHistoryPage',
              component: resolve => require(['@/components/operationArea/packHistoryPage.vue'], resolve),
              name: '拆包历史',
              hidden: true
            },
            {
              path: '/storeOperation/packHistoryPage',
              component: resolve => require(['@/components/operationArea/packHistoryPage.vue'], resolve),
              name: '打包历史',
              hidden: true
            },
            {
              path: '/storeOperation/unPackBagPage',
              component: resolve => require(['@/components/operationArea/unPackBagPage.vue'], resolve),
              name: '邮袋拆包',
              hidden: true
            },
            {
              path: '/storeOperation/packPage',
              component: resolve => require(['@/components/operationArea/packPage.vue'], resolve),
              name: '打包',
              nameEn:'Pack',
              selected: '../../static/images/menu/ic_pack_selected.png',
              normal: '../../static/images/menu/ic_pack_normal.png',
              childArr:[
                '/storeOperation/packHistoryPage',
                '/storeOperation/packCompletePage',
              ],
              warehouseType:[2]
            },
            {
              path: '/storeOperation/packCompletePage',
              component: resolve => require(['@/components/operationArea/packCompletePage.vue'], resolve),
              name: '打包操作',
              hidden: true
            },
            {
              path: '/storeOperation/spellBagPage',
              component: resolve => require(['@/components/operationArea/spellBagPage.vue'], resolve),
              name: '拼袋',
              nameEn:'Merge',
              selected: '../../static/images/menu/ic_spell_bag_selected.png',
              normal: '../../static/images/menu/ic_spell_bag_normal.png',
              childArr:[
                '/storeOperation/spellBagMeasurePage',
                '/storeOperation/spellBagAddOrderPage',
                '/storeOperation/spellBagHistoryPage',
              ],
              warehouseType:[2]
            },
            {
              path: '/storeOperation/spellBagMeasurePage',
              component: resolve => require(['@/components/operationArea/spellBagMeasurePage.vue'], resolve),
              name: '邮袋测量',
              hidden: true
            },
            {
              path: '/storeOperation/spellBagAddOrderPage',
              component: resolve => require(['@/components/operationArea/spellBagAddOrderPage.vue'], resolve),
              name: '邮袋添加订单',
              hidden: true
            },
            {
              path: '/storeOperation/spellBagHistoryPage',
              component: resolve => require(['@/components/operationArea/spellBagHistoryPage.vue'], resolve),
              name: '拼袋历史',
              hidden: true
            },
            {
              path: '/storeOperation/errorOrderPage',
              component: resolve => require(['@/components/operationArea/errorOrderPage.vue'], resolve),
              name: '异常件处理',
              nameEn:'Anomalous',
              selected: '../../static/images/menu/ic_abnormal_selected.png',
              normal: '../../static/images/menu/ic_abnormal_normal.png',
              childArr:[
                '/storeOperation/errorHistoryPage',
                '/storeOperation/errorOperationPage',
              ],
              warehouseType:[2]
            },
            {
              path: '/storeOperation/errorHistoryPage',
              component: resolve => require(['@/components/operationArea/errorHistoryPage.vue'], resolve),
              name: '异常件历史',
              hidden: true
            },
            {
              path: '/storeOperation/errorOperationPage',
              component: resolve => require(['@/components/operationArea/errorOperationPage.vue'], resolve),
              name: '异常件操作',
              hidden: true
            },
            {
              path: '/storeOperation/storedCapacityPage',
              component: resolve => require(['@/components/operationArea/capacity/inStoredPage.vue'], resolve),
              selected: '../../static/images/menu/ic_pack_selected.png',
              normal: '../../static/images/menu/ic_pack_normal.png',
              name: '库内列表',
              nameEn: 'Inside list',
              warehouseType:[4]
            },
            {
              path: '/storeOperation/returnCapacityPage',
              component: resolve => require(['@/components/operationArea/capacity/returnPage.vue'], resolve),
              name: '退库处理',
              nameEn:'Anomalous',
              selected: '../../static/images/menu/ic_abnormal_selected.png',
              normal: '../../static/images/menu/ic_abnormal_normal.png',
              childArr:[
                '/storeOperation/returnCapacityHistoryPage',
                '/storeOperation/returnCapacityOperaPage',
              ],
              warehouseType:[4]
            },
            {
              path: '/storeOperation/returnCapacityHistoryPage',
              component: resolve => require(['@/components/operationArea/capacity/returnHistoryPage.vue'], resolve),
              name: '退件历史',
              hidden: true
            },
            {
              path: '/storeOperation/returnCapacityOperaPage',
              component: resolve => require(['@/components/operationArea/capacity/returnOperaPage.vue'], resolve),
              name: '退库单',
              hidden: true
            },
          ]
        },
        {
          path: '/outStore',
          name: '出库',
          nameEn:'Outbound',
          component: resolve => require(['@/components/documentPage.vue'], resolve),
          selected: '../../static/images/menu/ic_first_out_store_selected.png',
          normal: '../../static/images/menu/ic_first_out_store_normal.png',
          children: [
            {
              path: '/outStore/outStorePage',
              component: resolve => require(['@/components/operationArea/outStorePage.vue'], resolve),
              name: '出货',
              nameEn:'Shipment',
              selected: '../../static/images/menu/ic_out_store_selected.png',
              normal: '../../static/images/menu/ic_out_store_normal.png',
              childArr:[
                '/outStore/outStoreHistoryPage',
              ],
              warehouseType:[1,2]
            },
            {
              path: '/outStore/outStoreHistoryPage',
              component: resolve => require(['@/components/operationArea/outStoreHistoryPage.vue'], resolve),
              name: '出库历史',
              hidden: true
            },
            {
              path: '/outStore/outStoreCapacityPage',
              component: resolve => require(['@/components/operationArea/capacity/outStoreCapacityPage.vue'], resolve),
              name: '出货',
              nameEn:'Shipment',
              selected: '../../static/images/menu/ic_out_store_selected.png',
              normal: '../../static/images/menu/ic_out_store_normal.png',
              childArr:[
                '/outStore/outStoreCapacityCompletePage',
                '/outStore/outStoreCapacityHistoryPage',
              ],
              warehouseType:[4]
            },
            {
              path: '/outStore/outStoreCapacityCompletePage',
              component: resolve => require(['@/components/operationArea/capacity/outStoreCapacityCompletePage.vue'], resolve),
              name: '运力出库操作',
              hidden: true
            },
            {
              path: '/outStore/outStoreCapacityHistoryPage',
              component: resolve => require(['@/components/operationArea/capacity/outStoreCapacityHistoryPage.vue'], resolve),
              name: '运力出库历史',
              hidden: true
            },
          ]
        },
        {
          path: '/print',
          name: '打印',
          nameEn:'print',
          component: resolve => require(['@/components/documentPage.vue'], resolve),
          selected: '../../static/images/menu/ic_first_print_selected.png',
          normal: '../../static/images/menu/ic_first_print_normal.png',
          children: [
            {
              path: '/print/printerPage',
              component: resolve => require(['@/components/operationArea/printerPage.vue'], resolve),
              name: '面单打印',
              nameEn: 'Printing',
              selected: '../../static/images/menu/ic_printer_selected.png',
              normal: '../../static/images/menu/ic_printer_normal.png',
              warehouseType:[1,2,4]
            },
          ]
        },
        {
          path: '/manage',
          name: '管理',
          nameEn:'Setup',
          component: resolve => require(['@/components/documentPage.vue'], resolve),
          selected: '../../static/images/menu/ic_first_manage_selected.png',
          normal: '../../static/images/menu/ic_first_manage_normal.png',
          children: [
            {
              path: '/manage/shopInspection',
              component: resolve => require(['@/components/manageArea/shopInspectionPage.vue'], resolve),
              name: '质检',
              nameEn:'Inspect',
              selected: '../../static/images/menu/ic_examine_selected.png',
              normal: '../../static/images/menu/ic_examine_normal.png',
              warehouseType:[2]
            },
            {
              path: '/manage/verifyClaimPage',
              component: resolve => require(['@/components/manageArea/verifyClaimPage.vue'], resolve),
              name: '认领验证',
              nameEn:'Claim',
              selected: '../../static/images/menu/ic_unknow_selected.png',
              normal: '../../static/images/menu/ic_unknow_normal.png',
              warehouseType:[2]
            },
            {
              path: '/manage/verifyClaimOperaPage',
              component: resolve => require(['@/components/manageArea/verifyClaimOperaPage.vue'], resolve),
              name: '认领验证操作',
              hidden: true
            },
            {
              path: '/manage/verifyClaimHistoryPage',
              component: resolve => require(['@/components/manageArea/verifyClaimHistoryPage.vue'], resolve),
              name: '认领验证历史',
              hidden: true
            },
            {
              path: '/manage/rockManagePage',
              component: resolve => require(['@/components/manageArea/RockManagePage.vue'], resolve),
              name: '库位管理',
              nameEn:'Location',
              selected: '../../static/images/menu/ic_rock_manage_selected.png',
              normal: '../../static/images/menu/ic_rock_manage_normal.png',
              warehouseType:[1,2,4]
            },
            {
              path: '/manage/rockManagePage1',
              component: resolve => require(['@/components/manageArea/rockManagePage1.vue'], resolve),
              name: '库位管理',
              nameEn:'Location',
              selected: '../../static/images/menu/ic_rock_manage_selected.png',
              normal: '../../static/images/menu/ic_rock_manage_normal.png',
              warehouseType:[1,2,4]
            },
          ]
        },
        {
          path: '/welcome',
          component: resolve => require(['@/components/operationArea/welcome.vue'], resolve),
          name: '欢迎页',
          hidden: true
        },
      ]
    },
    {
      path: '/stopSupportPage',
      component: resolve => require(['@/components/operationArea/stopSupportPage.vue'], resolve),
      name: '暂不支持',
      hidden: true
    },
    {
      path: '/testPrinter',
      component: resolve => require(['@/components/testPrinter.vue'], resolve),
      name: '测试打印',
      hidden: true
    },
    {
      path: '/cloudPrinter',
      component: resolve => require(['@/components/cloudPrinter.vue'], resolve),
      name: '局域网打印',
      hidden: true
    },
    {
      path: '/helpCenter',
      component: resolve => require(['@/components/helpCenter/helpCenter.vue'], resolve),
      name: '帮助中心',
      hidden: true
    },
    {
      path: '/webHelpDetail',
      component: resolve => require(['@/components/helpCenter/webHelpDetail.vue'], resolve),
      name: '新用户指导详情',
      hidden: true
    }
  ],
})




// WEBPACK FOOTER //
// ./src/router/index.js